import {
  LOG_OUT,
  RESET_PROFILE,
  SET_ACCOUNT_ACCESS,
  SET_NO_ACCOUNTS,
  SET_PROFILE,
  SET_PROFILE_ID,
  SET_PROFILE_PICTURE,
  SET_SMS_SETTING,
} from "../actions/actionsTypes";

const initialState = {};

export const profileReducer = (state = initialState, actions) => {
  if (actions.type === SET_PROFILE) {
    return {
      ...state,
      ...actions.payload,
    };
  }

  if (actions.type === SET_PROFILE_ID) {
    return {
      ...state,
      ...actions.payload,
    };
  }

  if (actions.type === SET_ACCOUNT_ACCESS) {
    return {
      ...state,
      access: actions.payload.restrictAccess,
    };
  }

  if (actions.type === SET_NO_ACCOUNTS) {
    return {
      ...state,
      noAccounts: true,
    };
  }

  if (actions.type === RESET_PROFILE || actions.type === LOG_OUT) {
    return initialState;
  }

  if (actions.type === SET_PROFILE_PICTURE) {
    return {
      ...state,
      profilePicturePath: actions.payload,
    };
  }

  if (actions.type === SET_SMS_SETTING) {
    return {
      ...state,
      smsSettingEnable: actions.payload,
    };
  }

  return state;
};
